
'use strict';

import $ from 'jquery';
import _ from 'underscore';
import mediator from '../../js/mediator';
import config from '../../js/config';
import ShowHide from '../../js/components/ShowHide';
import {FooterContactTabPanelView} from './FooterContactTabPanelView';
import FooterWeChatModal from './_Footer-weChatModal'

export var FooterContactTabView = ShowHide.extend({

  el: '.Footer-contact',
  animation: 'fade',
  legacy: {
    clickElements: '.Footer-contact-tabs [data-panel]',
    clickDisplayArray: '.Footer-contact-panel'
  },
  events: {
    'keydown .Footer-contact-tab': 'onKeydown'
  },

  initialize: function(options) {
    _.bindAll(this, 'initializeEvents', 'onChatOnline', 'onChatOffline');
    // Create panel views
    this.$('.Footer-contact-panel').each(function() {
      new FooterContactTabPanelView($(this));
    });
    this.setup(options);
    this.initializeEvents();
    this.initWechatIconTooltip();
    this.$contents = this.$el.find('.Footer-contact-tab');
    this.$contentbody = this.$el.find('.Footer-contact-panel');
    this.$newsletterbutton = this.$el.find('.Footer-newsletter-anchor');
    this.$chatlivebutton = this.$el.find('.Footer-chat-button');
    this.footerTabstructure();
  },

  toggletabs() {
    let newsletterTab = this.$contents.eq(0);
    let chatTab = this.$contents.eq(1);

    if (newsletterTab.hasClass('is-selected')) {
      newsletterTab.attr('aria-selected',true);
      newsletterTab.attr('tabindex','0');
      chatTab.attr('aria-selected',false);
      chatTab.attr('tabindex','-1');
    }
    else {
      chatTab.attr('aria-selected',true);
      chatTab.attr('tabindex','0');
      newsletterTab.attr('aria-selected',false);
      newsletterTab.attr('tabindex','-1');
    }
  },

  footerTabstructure() {
    let newsletterTab = this.$contents.eq(0);
    let chatTab = this.$contents.eq(1);
    let newsLetterBody = this.$contentbody.eq(0);
    let chatbody = this.$contentbody.eq(1);
    newsletterTab.attr('aria-selected',true);
    newsletterTab.attr('tabindex','0');
    newsletterTab.attr('aria-controls','footer-body-1');
    chatTab.attr('aria-controls','footer-body-2');
    chatTab.attr('aria-selected',false);
    chatTab.attr('tabindex','-1');
    newsletterTab.attr('id','footer-heading-1');
    chatTab.attr('id','footer-heading-2');
    newsLetterBody.attr('id','footer-body-1');
    chatbody.attr('id','footer-body-2');
    let newsletterSpan = document.createElement('span');
    newsletterSpan.id = 'signupText';
    newsletterSpan.innerHTML = newsLetterBody.text().replace(this.$newsletterbutton.text(), '').trim();
    newsletterSpan.className = 'Footer-newsletter-sr-only';
    this.$newsletterbutton[0].parentNode.appendChild(newsletterSpan);
    this.$newsletterbutton.attr('aria-describedBy','signupText');
    let chatliveSpan = document.createElement('span');
    chatliveSpan.id = 'chatliveText';
    chatliveSpan.innerHTML = chatbody.text().replace(this.$chatlivebutton.text(), '').trim();
    chatliveSpan.className = 'Footer-newsletter-sr-only';
    this.$chatlivebutton[0].parentNode.appendChild(chatliveSpan);
    this.$chatlivebutton.attr('aria-describedBy','chatliveText');
  },

  initWechatIconTooltip() {
    let $weChatIcon = $('#wechatSocialLink');

    if (!$weChatIcon.length) {
      return;
    }

    let imageUrl = $weChatIcon.data('wechatQrcode');

    if (_.isUndefined(imageUrl)) {
      return;
    }

    $weChatIcon.on('click', (e) => {
      e.preventDefault();

      this.popWeChatModal({
        title: 'WeChat QR Code',
        qrImageUrl: imageUrl,
        analyticsConfig: null
      });
    });
  },

  popWeChatModal(addToModalData) {
    let modal = new FooterWeChatModal();
    modal.open(addToModalData);
  },

  initializeEvents: function() {
    this.$('.Footer-newsletter-anchor').on('click', () => {
      mediator.trigger(config.events.footer.subscribe, this);
    });
    mediator.on(config.events.chat.online,  this.onChatOnline);
    mediator.on(config.events.chat.offline, this.onChatOffline);
  },

  onChatOnline: function() {
    this.$('.Footer-contact-chat-tab').addClass(config.classes.isLive);
  },

  onChatOffline: function() {
    this.$('.Footer-contact-chat-tab').removeClass(config.classes.isLive);
  },

  onKeydown(event) {
    var $newTarget = null;
    var $target = $(event.currentTarget);
    switch (event.key) {
      case 'ArrowLeft':
        var $prev = $target.prev();
        if ($prev && $prev.length)
        {
          $newTarget = $prev;
        }
        else {
          var $siblings = $target.siblings();
          $newTarget = $($siblings[$siblings.length - 1]);
        }
        break;
      case 'ArrowRight':
        var $next = $target.next();
        if ($next && $next.length)
        {
          $newTarget = $next;
        }
        else {
          var $siblings = $target.siblings();
          $newTarget = $($siblings[0]);
        }
        break;
      default:
        break;
    }
    if ($newTarget) {
      $newTarget.focus();
      $newTarget.click();
      this.toggletabs();
      event.stopPropagation();
      event.preventDefault();
    }
  }

});




// WEBPACK FOOTER //
// ./assets/components/Footer/FooterContactTabView.js